import { Spin } from 'antd';
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { PermissionCode, RoleCode } from '../../features/auth/types/auth';

interface Props {
  children: ReactNode;
  requiredRoles?: RoleCode | RoleCode[];
  requiredPermissions?: PermissionCode | PermissionCode[];
  loadingFallback?: ReactNode;
}

const ProtectedRoute = ({ children, requiredPermissions, requiredRoles, loadingFallback }: Props) => {
  const location = useLocation();
  const { isAuthenticated, hasPermission, hasRole } = useAuthStore();
  const bypassAuth = import.meta.env.VITE_BYPASS_AUTH === 'true';

  if (bypassAuth && !isAuthenticated()) {
    useAuthStore.getState().login({
      accessToken: 'dev-bypass-token',
      refreshToken: 'dev-bypass-refresh',
      user: {
        id: 'dev-user',
        email: 'dev@tkte.local',
        fullName: 'Dev User',
        roles: ['admin'],
        permissions: ['*', 'projects.read', 'projects.write']
      }
    });
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requiredRoles && !hasRole(requiredRoles)) {
    return <Navigate to="/" replace />;
  }

  if (requiredPermissions && !hasPermission(requiredPermissions)) {
    return <Navigate to="/" replace />;
  }

  if (!children) {
    return loadingFallback ?? <Spin />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
